module.exports = __webpack_public_path__ + "img/Invagora.cfc9a4a8.png";